
import styles from './index.module.scss'
import Utils from '@utils/utils'
import Iconfont from '@utils/Iconfont';
import { Image, Upload } from 'antd';
import { useState, useRef } from 'react';
import API from "@api/api";
import { BATCH_IMAGES_TYPE, MATTING_OPT_TYPE, BATCH_RECORD_TYPE } from "@utils/CONST"
import MattingOptModal from '../../components/MattingOptModal';


const TableUploadView = (props) => {
    const { url, type, width, item, projectId, onReupload, isEdit, projectType, dataSource, setDataSource } = props
    const [visible, setVisible] = useState(false);
    const mattingOptModalRef = useRef(null);
    const editedMask = props.item?.inputImages?.filter(item => item.mainImage === true)[0]?.editedMask

    const deleteImage = async () => {
        if (type == BATCH_RECORD_TYPE.MAINIMG || type == BATCH_RECORD_TYPE.MATCHIMG) {
            const updatedInputImages = type == BATCH_RECORD_TYPE.MAINIMG ?
                item.inputImages.filter(item => item.mainImage === false) :
                item.inputImages.filter(item => item.mainImage === true)
            const saveRes = await API.batchSaveSku([{
                ...item,
                inputImages: updatedInputImages,
                projectId
            }])
            if (saveRes?.code === 0) props.listSkuByProject(isEdit ? paramsData : null)
        } else if (type == BATCH_RECORD_TYPE.SIM_RECOLOR_INPUT) {
            setDataSource(prev =>
                prev.map(item =>
                    item.skuId === props.item.skuId
                        ? {
                            ...item,
                            inputCloth: ''
                        } : item
                )
            )
        } else if (type == BATCH_RECORD_TYPE.SIM_RECOLOR_MATCH) {
            setDataSource(prev =>
                prev.map(item =>
                    item.skuId === props.item.skuId
                        ? {
                            ...item,
                            matchCloth: ''
                        } : item
                )
            )
        }
    }


    return (
        <div className={styles.TableUploadView}>
            <div className={styles.ImageCell} style={{ width: width }} >
                <img src={Utils.getImgThumbnail(url)} alt="" />
                {
                    (editedMask?.repaintForegroundAlphaMask && type == BATCH_RECORD_TYPE.MAINIMG)
                    && <img src={Utils.getImgThumbnail(editedMask?.repaintForegroundAlphaMask)} alt="" />
                }
                {
                    !isEdit && <div className={styles.maskBox}>
                        <p onClick={() => setVisible(true)}><Iconfont className={styles.Icon} type="icon-FullscreenOutlined" /><span>查看大图</span></p>
                        <p onClick={() => {
                            const input = document.createElement('input');
                            input.type = 'file';
                            input.accept = 'image/jpeg,image/png,image/webp,image/avif';
                            input.onchange = (e) => {
                                const file = e.target.files[0];
                                if (file && onReupload) {
                                    console.log(file)
                                    onReupload(file, [file], item, type)
                                }
                            };
                            input.click();
                        }}><Iconfont className={styles.Icon} type="icon-ReuploadOutlined" /><span>重新上传</span></p>
                        {
                            (projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH && type === BATCH_RECORD_TYPE.MAINIMG) &&
                            <p onClick={() => mattingOptModalRef.current.open(item, MATTING_OPT_TYPE.REPAINT)}><Iconfont className={styles.Icon} type="icon-pencil" /><span>编辑选区</span></p>
                        }
                        {type != BATCH_RECORD_TYPE.MAINIMG && <p onClick={() => deleteImage()}><Iconfont className={styles.Icon} type="icon-DeleteOutlined" /><span>删除图片</span></p>}
                    </div>
                }

            </div>

            <Image
                style={{ display: 'none' }}
                src={Utils.getImgThumbnail(url)}
                preview={{
                    visible,
                    src: Utils.getImgThumbnail(url),
                    onVisibleChange: value => {
                        setVisible(value);
                    },
                }}
            />
            <MattingOptModal
                ref={mattingOptModalRef}
                projectType={projectType}
                dataSource={dataSource}
                setDataSource={setDataSource} />
        </div>
    )
}

export default TableUploadView